module.exports = __webpack_public_path__ + "img/zw.8b885465.svg";